var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{attrs:{"flat":"","absolute":"","bottom":"","color":"transparent","width":"100%"}},[_c('v-row',{attrs:{"dense":"","justify":"end"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }